import {
  LOGIN_USER,
  LOGIN_OTP,
  LOGIN_SUCCESS,
  GET_CURRENT_USER,
  GET_CURRENT_USER_SUCCESS,
  GET_CURRENT_USER_FAIL,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  GET_LANGUAGES,
  GET_LANGUAGES_SUCCESS,
  GET_LANGUAGES_FAIL,
  LOGIN_USER_FAIL,
  SOCIAL_LOGIN_REQUEST, SOCIAL_LOGIN_SUCCESS, SOCIAL_LOGIN_FAIL,
  GET_ACCES_TOKEN_INFO,GET_ACCES_INFO_SUCCESSFULL,GET_ACCES_INFO_FAILED,
  CHANGE_PASSWORD, CHANGE_PASSWORD_SUCCESS,CHANGE_PASSWORD_FAIL,
  EDIT_PROFILE, EDIT_PROFILE_SUCCESS,EDIT_PROFILE_FAIL,
  SET_PASSWORD, SET_PASSWORD_FAIL, SET_PASSWORD_SUCCESS



} from "./actionTypes"

const { data, ...authUser } = JSON.parse(
  localStorage.getItem("authUser") || "{}",
)

const initialState = {
  meLoading: false,
  isMeFailed: false,
  error: "",
  loading: false,
  user: data || {},
  authToken: data?.Token || null,
  languages: [],
  timezones: [],
  countries: [],
  currencies: [],

  accessTokenInfo:{}
}
 /**
      * Used for handled the api response and callbacks
      */
const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      return {
        ...state,
        error: "",
        loading: true,
      }
    case LOGIN_OTP:
      return {
        ...state,
        error: "",
        loading: true,
      }
    case LOGIN_SUCCESS:
      return {
        ...state,
        error: "",
        user: action.payload.data,
        authToken: action.payload.data.Token,
        loading: false,
      }


    case LOGIN_USER_FAIL:
      return {
        ...state,
        user: null,
        loading: false,
        authToken: null,

      }

    case LOGOUT_USER:
      return { ...state }
    case LOGOUT_USER_SUCCESS:
      return { ...state, user: {}, authToken: null }
    case API_ERROR:
      return { ...state, error: action.payload, loading: false }

    case GET_LANGUAGES_SUCCESS:
      return { ...state, ...action.payload }



    case SOCIAL_LOGIN_REQUEST:
      return {
        ...state,
        error: "",
        loading: true,
      }


    case SOCIAL_LOGIN_SUCCESS:
      return {
        ...state,
        error: "",
        user: action.payload.data,
        authToken: action.payload.data?.Token,
        loading: false,
      }


    case SOCIAL_LOGIN_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false
      }



      case GET_ACCES_TOKEN_INFO:
        return {
          ...state,
        };
  
      case GET_ACCES_INFO_SUCCESSFULL:
        return {
          ...state,
          accessTokenInfo: action.payload || {},
          error: "",
        };
  
      case GET_ACCES_INFO_FAILED:
        return {
          ...state,
          accessTokenInfo: {},
          error: "",
        };


        case CHANGE_PASSWORD:
          return {
            ...state,
            error: "",
            loading: true,
          }
    
    
        case CHANGE_PASSWORD_SUCCESS:
          return {
            ...state,
            error: "",
            user: action.payload.data,
            loading: false,
          }
    
    
        case CHANGE_PASSWORD_FAIL:
          return {
            ...state,
            error: action.payload,
            loading: false
          }
          case EDIT_PROFILE:
            return {
              ...state,
              error: "",
              loading: true,
            }
      
      
          case EDIT_PROFILE_SUCCESS:
            return {
              ...state,
              error: "",
              user: action.payload.data,
              loading: false,
            }
      
      
          case EDIT_PROFILE_FAIL:
            return {
              ...state,
              error: action.payload,
              loading: false
            }
      


    default:
      return { ...state }
  }
  return state
}

export default login
